import { createContext } from "react";
import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";
import { TIMER_ERROR_INITIAL_VALUE, TimerError } from "../utils/timerError.utils";

export interface ISectionContext {
  timeLeft: number | null;
  isTimedOutSection: boolean;
  timerError: TimerError;
  currentSectionElement?: ILocalizedTestElement;
}

export const SectionContext = createContext<ISectionContext>({
  timeLeft: null,
  isTimedOutSection: false,
  timerError: TIMER_ERROR_INITIAL_VALUE,
});
